import React from 'react'
import { Paper, Typography, Box, RadioGroup, FormControlLabel, Radio, Stack } from '@mui/material'
import { CardStatus } from 'src/Libs/e-mobility/shared'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { MOCK_CHARGING_CARD_TO_BE_EDITED } from '../../mock-data/mock-charging-card-to-be-edited'

/** Charging cards edit charging card dialog step component */
export const EditChargingCardDialogStep: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Box>
      <Typography>{t('emobility.tour.charging-cards-edit-card-dialog')}</Typography>

      <Paper
        component="div"
        sx={theme => ({
          mt: 2,
          pointerEvents: 'none',
          opacity: 0.9,
          boxShadow: '0 0 0 2px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.3)', // More dramatic shadow
          overflow: 'hidden',
          transform: 'scale(0.95)',
          filter: 'grayscale(5%)',
          backgroundColor: '#fff',
          padding: 4,
          paddingBottom: 6,
        })}
      >
        <Typography fontWeight="bold">{t('emobility.charging-cards.manage-charging-card-details-dialog-title', { cardLabel: '' })}</Typography>
        <Typography variant="body2" component="p" mt={4}>
          {t('emobility.chargingCards.status.status')}
        </Typography>
        <RadioGroup aria-label="charging-card-status" defaultValue={CardStatus.active} onChange={() => undefined} sx={{ flexDirection: 'row' }}>
          <FormControlLabel
            name="status"
            value={CardStatus.active}
            control={<Radio color="primary" />}
            label={t('emobility.chargingCards.status.ACTIVE')}
          />
          <FormControlLabel
            name="status"
            value={CardStatus.rejected}
            control={<Radio color="primary" />}
            label={t('emobility.chargingCards.status.DENIED')}
          />
        </RadioGroup>
        <Stack direction="column" spacing={4} mt={4}>
          <TextField
            placeholder={t('emobility.chargingCards.edit.card-name')}
            value={MOCK_CHARGING_CARD_TO_BE_EDITED.cardName ?? undefined}
            onChange={() => undefined}
            label={t('emobility.chargingCards.edit.card-name')}
            name="cardName"
          />
          <TextField
            placeholder={t('emobility.chargingCards.edit.details')}
            value={MOCK_CHARGING_CARD_TO_BE_EDITED.description}
            onChange={() => undefined}
            label={t('emobility.chargingCards.edit.details')}
            name="description"
          />
        </Stack>
      </Paper>
    </Box>
  )
}
